<template>
  <div class="view-wrap index-view-wrap">
    <!-- <HeaderBar /> -->
    <router-view></router-view>
    <FooterBar />
  </div>
</template>

<script>
import FooterBar from '../components/FooterBar';
import { getUser } from '../utils/storageUtil';
import { Toast } from 'mint-ui'
export default {
  name: 'index',
  components: {
    FooterBar
  },

  watch: {
    '$route'(to, from){
      if(to.path=='/discover'){
        // let tag =getUser().jpush_status;
        const user = getUser();
        const tag = !!user ? user.jpush_status : '';
        if(!!window.HostApp){
          window.HostApp.pushMsg(tag);
        }
      }
    }
  }
};
</script>
